<mc-equation [equation]="equation"></mc-equation>